import { render, staticRenderFns } from "./SelectWeekNumber.vue?vue&type=template&id=b3fe461a&"
import script from "./SelectWeekNumber.vue?vue&type=script&lang=js&"
export * from "./SelectWeekNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports